import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import VendorVideoSidebar from "@/components/vendor-video/VendorVideoSidebar";
import VendorVideoHeader from "@/components/vendor-video/VendorVideoHeader";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const VendorVideoDashboardLayout: React.FC = () => {
  console.log("✅ VendorVideoDashboardLayout mounted");
  
  const { user, profile, isLoading } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  console.log("🔍 VendorVideoDashboardLayout - Auth state:", { 
    hasUser: !!user, 
    userRole: profile?.role, 
    isLoading 
  });

  useEffect(() => {
    console.log("🔄 VendorVideoDashboardLayout useEffect - checking auth");
    
    // Check if user is authenticated and has vendor_video membership
    if (!isLoading) {
      console.log("✅ Auth loading complete, checking permissions");
      
      if (!user) {
        console.log("❌ No user found, redirecting to login");
        navigate('/auth/login', { state: { from: '/vendor-video-dashboard' } });
        return;
      }
      
      if (profile?.active_membership_slug !== 'vendor_video') {
        console.log("❌ User does not have vendor_video membership, redirecting to dashboard");
        toast.error("You don't have video vendor privileges to access this area");
        navigate('/dashboard');
        return;
      }
      
      console.log("✅ Video vendor access confirmed");
    }
  }, [user, profile, isLoading, navigate]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Show loading state while checking authentication
  if (isLoading) {
    console.log("⏰ VendorVideoDashboardLayout showing loading state");
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <span className="ml-2 text-lg font-medium">Loading...</span>
      </div>
    );
  }

  // If not vendor_video membership, the useEffect will handle the redirect
  if (!user || profile?.active_membership_slug !== 'vendor_video') {
    console.log("🚫 VendorVideoDashboardLayout - No access, returning null");
    return null;
  }

  console.log("🎯 VendorVideoDashboardLayout rendering main layout");

  return (
    <div className="h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
      <VendorVideoHeader toggleSidebar={toggleSidebar} />
      <div className="flex flex-1 overflow-hidden">
        <VendorVideoSidebar isOpen={sidebarOpen} />
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default VendorVideoDashboardLayout;